import GoogleBtn from './google-button';

export default GoogleBtn;
